import { useEffect, useState } from "react";

function getCookie(name: string): string | null {
    const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
}

export function useCookie(name: string, interval = 1000) {
    const [value, setValue] = useState<string | null>(() =>
        typeof document !== "undefined" ? getCookie(name) : null
    );

    useEffect(() => {
        let prev = getCookie(name);

        const timer = setInterval(() => {
            const current = getCookie(name);

            if (current !== prev) {
                prev = current;
                setValue(current);
            }
        }, interval);

        return () => clearInterval(timer);
    }, [name, interval]);

    return value;
}